/* The teddy selection slides of the product carousel (snippet
 * custom-teddy-selection). A cover thumbnail moves to its teddy by
 * pressing the teddy's tab, so Dawn's slideshow-component does the scrolling. Select
 * checks the teddy's radio in custom-product's hidden <variant-radios> and
 * fires its change event, so custom-variant-radios.js switches the variant;
 * the teddy's name goes into the buy button after its label ("Add to
 * shopping bag | No. 2"), in a span of its own, because the variant switch
 * rewrites the label span.
 */
(() => {
  if (window.ltsTeddySelection) return;
  window.ltsTeddySelection = true;

  function select(slide) {
    const value = slide.dataset.optionValue;
    const radio = Array.from(document.querySelectorAll('variant-radios input[type="radio"]')).find(
      (input) => input.value === value
    );
    if (radio && !radio.checked) {
      // The variant switch disables the buy button until the new variant has
      // loaded; is-switching keeps its label (the short "Buy" on narrow
      // screens) from flashing to the long one meanwhile.
      const buttons = document.querySelectorAll('.mainproduct__content__right .product-form__submit');
      buttons.forEach((b) => b.classList.add('is-switching'));
      const done = () => buttons.forEach((b) => b.classList.remove('is-switching'));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          unsubscribe();
          done();
        });
      }
      setTimeout(done, 5000);
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    document.querySelectorAll('.product-hero__slide--teddy').forEach((teddy) => {
      teddy.classList.toggle('is-selected', teddy === slide);
      teddy.classList.remove('is-default');
    });

    document.querySelectorAll('.product-form__submit-teddy').forEach((label) => {
      label.textContent = slide.dataset.teddyName;
      label.hidden = false;
    });
  }

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('.teddy-selection__thumb');
    if (thumb) {
      const tabs = document.querySelectorAll('.product-hero__tab--teddy-cover ~ .product-hero__tab');
      const tab = tabs[Number(thumb.dataset.teddyIndex) - 1];
      if (tab) tab.click();
    }
    const button = event.target.closest('.teddy-selection__select');
    if (button) select(button.closest('.product-hero__slide--teddy'));
  });

  // Nothing is selected until the visitor picks a teddy, so the buy button
  // starts without a name. The teddy an unpicked purchase gets (the checked
  // radio: the first available, the queue's first held one, or the one a
  // ?variant= URL names) shows as Selected meanwhile.
  const checked = document.querySelector('variant-radios input[type="radio"]:checked');
  const fallback = checked && Array.from(document.querySelectorAll('.product-hero__slide--teddy')).find(
    (teddy) => teddy.dataset.optionValue === checked.value
  );
  if (fallback) fallback.classList.add('is-default');
})();
